import Photo from './Photo';
import LinkText from './LinkText';
import SmartLink from './SmartLink';
import { Horizon, Peeks, splitArt } from './Art';

export default function About({ about, art, loading }) {
  const { heading, intro, photo, focus, alt, story, links } = about;
  const [lead, ...rest] = story;
  const { peeks, horizon } = splitArt(art);
  return (
    <section id="about" className={`sec sec--paper about ${horizon ? 'sec--horizon' : ''}`} aria-labelledby="about-title">
      <Peeks items={peeks} />
      <div className="wrap">
        <div className="split">
          <h2 id="about-title" className="display">{heading}</h2>
          {intro.length > 0
            ? <div>{intro.map((p, i) => <p key={i} className="lede"><LinkText text={p} /></p>)}</div>
            : loading && <p className="lede skeleton" aria-hidden="true">&nbsp;</p>}
        </div>

        {photo && (
          <figure className="panorama tile-frame">
            <Photo src={photo} alt={alt} position={focus} />
          </figure>
        )}

        {(lead || rest.length > 0) && (
          <div className="split story">
            {lead && <p className="story-lead"><LinkText text={lead} /></p>}
            <div className="story-body">
              {rest.map((p, i) => <p key={i}><LinkText text={p} /></p>)}
              {links.length > 0 && (
                <p className="story-links">
                  {links.map((l) => <SmartLink key={l.key} className="btn btn--line" url={l.url}>{l.label}</SmartLink>)}
                </p>
              )}
            </div>
          </div>
        )}
      </div>
      {horizon && <Horizon name={horizon.name} />}
    </section>
  );
}
